var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


///////////////////////////////////////////
setInterval( animation_shake, 3000 );
var i = 1;
function animation_shake()
{
    jQuery('.home-banner').find('.active').removeClass('active');    
   
    jQuery('.shake-top'+i).addClass('active');

    if(i == 5)
    {
      i = 1;
    }
    else 
    {
    i++;
    }
}

////WE OFFER PEOPLE home page slider////
$('.home-products-slider').owlCarousel({
    center: true,
    items:5,
    loop:true,
    dots:false,
    nav:true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 3000,
    // animateIn: 'linear',
    // animateOut: 'linear',
    autoplayHoverPause:true,
    margin:10,
    responsive:{
        1200:{
            items:5           
        },
        768:{
            items:3
        },
        576:{
            items:2
           
        },
        0:{
            items:1
           
        }
    }
});

if($('.product-large-box').length > 0)
{
/*Product Details thumb images*/
$('.product-large-box').slick({
  dots: true,
  infinite: false,
     arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

}
/*----------------*/



/*-----------megamenu toggle--------------*/

    $(".mega-nav-ui").click(function(){
      $(".food-mega-menu").slideToggle();
      
    });

    $(".close-btn-ui").click(function(){
        $(".food-mega-menu").slideToggle(500);
      });

    $(".food-items").click(function(){
        $(".list-food").slideToggle(500);
      });


///left slide menu-----------
      function openNav() {
        document.getElementById("myNav").style.width = "100%";
      }
    
      function closeNav() {
        document.getElementById("myNav").style.width = "0%";
      }



/*---------------sticky header--------------*/

$(window).scroll(function(){
    if ($(window).scrollTop() >= 200) {
        $('.header-main-height').css('height','100px');
        $('.header-main').addClass('fixed-header');
        $('.header-main').addClass('visible-title');
    }
    else {
        $('.header-main-height').css('height','auto');
        $('.header-main').removeClass('fixed-header');
        $('.header-main').removeClass('visible-title');
    }
});




/*Product Details page Qty Plus Min*/
	$(document).ready(function() {
			$('.minus').click(function () {
				var $input = $(this).closest('.number').find('input');
				var count = parseInt($input.val()) - 1;
				count = count < 1 ? 1 : count;
				$input.val(count);
				$input.change();
              updateProductPrice()
				return false;
			});
			$('.plus').click(function () {
				var $input = $(this).closest('.number').find('input');
				$input.val(parseInt($input.val()) + 1);
				$input.change();
              updateProductPrice()
				return false;
			});
		});

function updateProductPrice(){
  var varID = $("select[name='id']").val();
  var varPrice = parseInt($("select[name='id'] option[value='"+varID+"']").attr("data-price"));
  var varQty = $("input[name='quantity']").val();
  $(".product_price").html(Shopify.formatMoney((varPrice * varQty), Shopify.money_format));
}

/*Product Details page slide with Qty Plus Min*/
myData = [ 1,3,6,12 ];
price = [ 10.00,20.00,30.00,40.00 ];

		slider_config = {
		//	range: true,
			min: 0,
			max: myData.length - 1,
			step: 1,
			 slide: function( event, ui ) {
			         // Set the real value into the inputs 
                   var selectedIndex = ui.value;
			         
                 var varID = $("select[name='id'] option:eq("+selectedIndex+")").attr("value");
                 var varPrice = parseInt($("select[name='id'] option:eq("+selectedIndex+")").attr("data-price"));
                  $("select[name='id']").val(varID).trigger("change");
                 updateProductPrice();

                // $('#from').val( myData[ ui.value ] );
                // $('#price').val( '$'+price[ parseFloat(ui.value) ] );			                   
			      },
			        /*    create: function() {
			                    $(this).slider('values',0,0);
			                  //  $(this).slider('values',1,myData.length - 1);
			            } */
		};

		// Render Slider
if($('#slider').length > 0)
{
    $('#slider').slider(slider_config);
}

//Enter
jQuery(document).on('click','.enter-btn',function()
{    
    $('#overlayer').remove();
    $('html').removeClass('no-scroll-y');
});

/*Loader page*/
// setTimeout(function() {
//   $('.loader').addClass('loaded');
//   $('html').removeClass('no-scroll-y'); 

//   if ($('.loader').hasClass('loaded')) 
//   {    
//     $('#overlayer').delay(1000).queue(function() 
//     { 
//       $(this).remove(); 
//     }); 
//   }
// }, 4000);

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

$(".newsletter-form-cus .subscribe-btn").on("click", function(e){
  var emailVal = $(this).parents("form").find("input[name='contact[email]']").val();
  $(".email-err").remove();
  console.log(emailVal)
  if(isEmail(emailVal)){
    console.log(true);
  }else{
   $(this).parents("form").find("input[name='contact[email]']").after("<p class='email-err'>Please add valid email.</p>");
    e.preventDefault();
    return false;
  }
});

